export const setMovementTypes = (listMovementType) => {
    return {
        type: 'LIST_MOVE_CODE',
        listMovementType,
    };
};

export const setMovementType = (movementType) => {
    return {
        type: 'SET_MOVE_CODE',
        movementType
    };
};

export const resetFilters = () => {
    return {
        type: 'RESET_FILTER',
    };
};
